import {
  GenericForm,
  GenericFormLogicalField,
  genericBeforeValidate_removeDefaultKeyedError,
  ValidationEvent,
  genericValidate_textField,
  GenericTextFieldValidationOptions,
} from "../../../hooks";

import { CheckoutRegions_Response } from "../../../providers/data-source-checkout-regions";

interface StateFormLogicProps<Form extends GenericForm, App extends unknown> {
  required?: boolean;

  guard?: GenericTextFieldValidationOptions<Form, App>["guard"];
}

export type AppMinimumRequirementsFor_StateFormLogic = {
  regions?: CheckoutRegions_Response;
};

export const stateFormLogic = <
  Form extends GenericForm,
  App extends AppMinimumRequirementsFor_StateFormLogic
>(
  props: StateFormLogicProps<Form, App> = {}
): GenericFormLogicalField<Form, App> => ({
  presentation: props,
  validationEvents: [
    ValidationEvent.onChange,
    ValidationEvent.onBlur,
    ValidationEvent.onSubmit,
  ],
  beforeValidate: genericBeforeValidate_removeDefaultKeyedError,
  validate: genericValidate_textField({
    required: props.required,
    guard: (context) => {
      if (
        !context.app.regions || !context.app.regions.available_regions ||
        context.app.regions.available_regions.length < 1
      ) {
        return false;
      }
      if (props.guard) {
        return props.guard(context);
      }
      return true;
    },
    valueMustBeOneOf(context) {
      return (context.app.regions?.available_regions || []).map(
        (region) => region.code
      );
    },
  }),
});
